export default __webpack_public_path__ + "static/media/promom.d0c56697.gif";